import AccessCodeModal from "./AccessCodeModal";

export default AccessCodeModal;